import React, { Component } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { FaRegImage } from 'react-icons/fa';
import { Mutation, compose, Query } from 'react-apollo';
import { bindActionCreators } from 'redux';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { get, pick } from 'lodash';
import { withAlert } from 'react-alert';

import { LoginContainer, SubmitButton } from './auth/Login';
import { loginUserAction } from '../actions/loginUser';
import { renameObjectForSelect } from '../constants/helper';
import Select from '../components/Form/Select';
import MultiSelect from '../components/Form/MultiSelect/MultiSelect';
import { ErrorMessage } from '../components/Form/styles';
import InputModal from '../components/Form/InputModal';
import { BtnContainer, FormContainer } from '../components/Form/styles';

import { EMAIL_VALIDATION_REGEXP } from '../constants/validationRegexp';

import successImage from '../images/success.png';
import CheckBox from '../components/Form/CheckBox';

const Container = styled(LoginContainer)`
  position: absolute;
  display: block;
  padding: 50px 15px;
  text-align: left;
  overflow: visible;
  width: 100%;
  background-color: white;

  .loginBox {
    margin: 0 auto;
    padding-top: 35px;
    margin-bottom: 20px;
  }
`;

const PublicFormContainer = styled.div`
  .formItem {
    margin-bottom: 10px;

    > div {
      min-height: 50px;
    }
  }
`;
const LogoContainer = styled.div`
  text-align: center;

  .regionLogo {
    max-width: 120px;
    height: auto;
    background-position: center;
    background-size: cover;
    margin: 10px auto;
  }
`;
const FullWidthFormGroup = styled.div`
  width: 100%;
`;

const Form = styled.form`
  text-align: left;
`;

export const SuccessTitle = styled.div`
  font-size: 20px;
  margin-top: 40px;
`;

export const SuccessImage = styled.img`
  width: 50px;
  height: 50px;
  margin: 25px auto 0;
`;

function validate(values) {
  const errors = {};

  if (values.name && values.name.length < 3) {
    errors.name = 'Name must be at least 3 characters long';
  }

  if (!values.name) {
    errors.name = 'Required';
  }

  if (values.email && !EMAIL_VALIDATION_REGEXP.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.email) {
    errors.email = 'Required';
  }

  if (!values.webSite) {
    errors.webSite = 'Required';
  }

  if (!values.categories) {
    errors.categories = 'Required';
  }

  if (values.categories && !values.categories.length) {
    errors.categories = 'Required';
  }

  if (!values.country) {
    errors.country = 'Required';
  }

  if (values.nominatedByName && values.nominatedByName.length < 3) {
    errors.nominatedByName = 'Name must be at least 3 characters long';
  }

  if (!values.nominatedByName) {
    errors.nominatedByName = 'Required';
  }

  if (values.nominatedByEmail && !EMAIL_VALIDATION_REGEXP.test(values.nominatedByEmail)) {
    errors.nominatedByEmail = 'Invalid email address';
  }

  if (!values.nominatedByEmail) {
    errors.nominatedByEmail = 'Required';
  }

  if (!values.checkbox) {
    errors.checkbox = 'Please read and accept the terms and conditions before proceeding';
  }

  return errors;
}

export const CREATE_NOMINATION = gql`
  mutation publicCreateNomination($nomination: PublicNominationInput!) {
    publicCreateNomination(nomination: $nomination) {
      id
    }
  }
`;

const GET_COMPETITION = gql`
  query publicGetCompetitionById($id: ID!) {
    publicGetCompetitionById(id: $id) {
      id
      name
      description
      image
      logoUrl
      region {
        image
      }
      categories {
        id
        name
        enabled
      }
      countriesList {
        id
        name
        flag
      }
    }
  }
`;

class PublicNomination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      success: false
    };
  }

  componentDidMount() {
    const { location, initialize } = this.props;
    const query = queryString.parse(location.search);

    initialize(pick(query, ['competition', 'name']));

    if (document.getElementById('scroll-content')) {
      document.getElementById('scroll-content').style.overflow = 'visible';
    }

    if (document.getElementById('side-bar')) {
      document.getElementById('side-bar').style.boxShadow = 'none';
    }
  }

  componentWillUnmount() {
    if (document.getElementById('scroll-content')) {
      document.getElementById('scroll-content').style.overflow = 'auto';
    }

    if (document.getElementById('side-bar')) {
      document.getElementById('side-bar').style.boxShadow = '2px 0 20px rgba(69,65,78,.07)';
    }
  }

  submitForm = async (data, mutation) => {
    const { alert } = this.props;
    try {
      const nomination = pick(data, [
        'name',
        'email',
        'webSite',
        'categories',
        'nominatedByName',
        'nominatedByEmail',
        'additionalField'
      ]);

      nomination.competition = {
        id: data.competition,
        name: ''
      };
      nomination.country = data.country.value;
      nomination.categories = nomination.categories.map(({ enabled, ...item }) => item);

      await mutation({ variables: { nomination } });
      this.setState({ success: true });
    } catch (error) {
      alert.error(error.message);
    }
  };

  getQueries = () => {
    const { location } = this.props;
    return queryString.parse(location.search);
  };

  ownerFields = () => {
    return (
      <div>
        <div className="formItem fullWidth wideLabel">
          <Field
            name="nominatedByName"
            component={InputModal}
            type="text"
            label="Your name (Your personal name that will not be disclosed to the nominee you are recommending)"
          />
        </div>
        <div className="formItem fullWidth wideLabel">
          <Field
            name="nominatedByEmail"
            component={InputModal}
            type="text"
            label="Your email (Your personal email that will not be disclosed to the nominee you are recommending)"
          />
        </div>
      </div>
    );
  };

  renderSecondPart = ({ data, error, loading }) => {
    const { submitting } = this.props;
    if (loading) return null;
    if (error)
      return (
        <FullWidthFormGroup>
          <ErrorMessage>Competition invalidate!</ErrorMessage>

          <BtnContainer>
            <SubmitButton disabled={submitting || error}>Invite</SubmitButton>
          </BtnContainer>
        </FullWidthFormGroup>
      );

    if (data && data.publicGetCompetitionById) {
      const competitionId = data.publicGetCompetitionById.id;
      const filteredCategories = data.publicGetCompetitionById.categories.filter((item) => {
        return item.enabled;
      });
      return (
        <FullWidthFormGroup>
          <div className="formItem fullWidth">
            <Field
              name="categories"
              component={MultiSelect}
              data={filteredCategories || []}
              textField="name"
              label="Category/categories to nominate for"
              type="categoryList"
            />
          </div>
          <div className="formItem fullWidth">
            <Field
              name="country"
              component={Select}
              options={
                data.publicGetCompetitionById.countriesList.map((item) =>
                  renameObjectForSelect(item)
                ) || []
              }
              label="Nominee's country (the country you are representing)"
            />
          </div>
          {this.ownerFields()}
          <Field
            name="checkbox"
            component={CheckBox}
            competitionId={competitionId}
            termsConditions
            checked={false}
          />
          <BtnContainer>
            <SubmitButton disabled={submitting || error}>Invite</SubmitButton>
          </BtnContainer>
        </FullWidthFormGroup>
      );
    }
    return null;
  };

  renderForm() {
    const { handleSubmit } = this.props;
    const query = this.getQueries();
    const competition = get(query, 'competition', null);

    return (
      <PublicFormContainer>
        <div className="loginBox">
          <Query query={GET_COMPETITION} variables={{ id: competition }} fetchPolicy="network-only">
            {({ client, loading, data, error }) => {
              if (loading) return <div>Loading</div>;
              if (error) return <div>{error.message}</div>;
              const region = data.publicGetCompetitionById.region;
              return (
                <LogoContainer>
                  {region.image ? (
                    <img className="regionLogo" src={region.image} alt="Logo" />
                  ) : (
                    <FaRegImage size="50" />
                  )}
                </LogoContainer>
              );
            }}
          </Query>

          <h2>Nomination form</h2>

          <Mutation mutation={CREATE_NOMINATION}>
            {(mutation) => (
              <Form onSubmit={handleSubmit((data) => this.submitForm(data, mutation))}>
                <div className="formItem fullWidth">
                  <Field
                    name="name"
                    component={InputModal}
                    type="text"
                    label="Nominee's name (Natural person or company you are nominating)"
                  />
                </div>
                <div className="formItem fullWidth">
                  <Field
                    name="email"
                    component={InputModal}
                    type="text"
                    label="Nominee's email address (Natural person or company's email address that you are nominating)"
                  />
                </div>
                <div className="formItem fullWidth">
                  <Field
                    name="webSite"
                    component={InputModal}
                    type="text"
                    label="Nominee's website"
                  />
                </div>
                <Query
                  query={GET_COMPETITION}
                  variables={{ id: competition }}
                  fetchPolicy="network-only"
                >
                  {this.renderSecondPart}
                </Query>
              </Form>
            )}
          </Mutation>
        </div>
      </PublicFormContainer>
    );
  }

  renderSuccessBlock() {
    return (
      <FormContainer>
        <div className="loginBox">
          <SuccessImage src={successImage} />
          <SuccessTitle>
            Your nomination was successful, an email has been sent to the nominee, and your name is
            not disclosed.
          </SuccessTitle>
        </div>
      </FormContainer>
    );
  }

  render() {
    const { success } = this.state;
    const query = this.getQueries();
    const competition = get(query, 'competition', null);
    if (competition) {
      return <Container>{success ? this.renderSuccessBlock() : this.renderForm()}</Container>;
    }
    return <Redirect to="/" />;
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginUserAction
    },
    dispatch
  );

const mapStateToProps = ({ form }) => ({
  competitionValue: get(form, 'publicNomination.values.competition.value', null)
});

export default compose(
  reduxForm({
    form: 'publicNomination',
    validate
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withAlert()
)(PublicNomination);
